import React from 'react';
import '../css/App.css';
import '../css/Product.css';
import ls from 'local-storage'
import {withRouter} from "react-router";
import urls from "../configs/urls";
class ItemStore extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            id:props.id,
            stores:props.stores,
            name:props.name,
            has_extra_items:props.has_extra_items,
        };
    }
    componentWillReceiveProps(props) {
        this.setState(
            {
                id:props.id,
                stores:props.stores,
                name:props.name,
                has_extra_items:props.has_extra_items,
            });

    }
    componentDidMount = () => {
        /*let stores = document.getElementsByClassName("itemStores");
        for(let i = 0; i < stores.length ; i++){
            stores[i].addEventListener('wheel', event => {
                let toLeft  = event.deltaY > 0 && stores[i].scrollLeft > 0;
                let toRight = event.deltaY < 0 && stores[i].scrollLeft < stores[i].scrollWidth - stores[i].clientWidth ;

                if (toLeft || toRight) {
                    event.preventDefault();
                    stores[i].scrollLeft -= event.deltaY;
                }
            });
        }*/
    };

    render() {
        let more = '';
        if(this.state.has_extra_items)
            more =  (<div className={"itemStoreMore"} onClick={()=>this.openMore(this.state.id)}>بیشتر ></div>);
        return (
            <div className={"itemStoreDiv"}>
                <div className={"itemStoreNav"}>
                    <div className={"itemStoreTitle"}>{this.state.name}</div>
                    {more}
                </div>
                <div className={"itemStores"}>
                    {this.state.stores.map((store)=>{
                        return (
                            <div className={"catShopElm"}  onClick={()=>this.handleShop(store.id)}>
                                <div className={"catShopImgElm"}>
                                    <img className={"catShopImg"} src={urls.SiteUrl+store.store_image}/>
                                </div>
                                <div className={"catShopText"}>{store.store_name}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
    handleShop(shopId){
        ls.set("store_id",shopId);
        this.props.history.push({
            pathname: '/store',
            state: {id:shopId}
        });
    }

    openMore = (id)=>{
        ls.set("item_id",id);
        this.props.history.push("/moreStores");
    }
}

export default withRouter(ItemStore);
